import { stockOnHandStatuses } from '../data/threePlStockOnHandData'

const stockonHand = {
  isLoading: false,
  list: [],
  sohCSVList: [],
  statuses: stockOnHandStatuses,
  locations: ['Adelaide', 'Brisbane', 'Cairns', 'Melbourne', 'Sydney'],
  searchFilters: {
    search: '',
    location: '',
    searchStatuses: [],
  },
}

const ThreePlStockOnHandReducer = function (state = stockonHand, action) {
  switch (action.type) {
    case 'TOGGLE_3PL_STOCK_ON_HAND_LOADING': {
      return {
        ...state,
        isLoading: action.payload,
      }
    }
    case 'SET_3PL_STOCK_ON_HAND_SEARCH': {
      return {
        ...state,
        searchFilters: {
          ...state.searchFilters,
          [action.key]: action.payload,
        },
      }
    }
    case 'SET_3PL_STOCK_ON_HAND_LIST': {
      return {
        ...state,
        list: action.payload,
      }
    }
    case 'SET_3PL_STOCK_ON_HAND_CSV_LIST': {
      return {
        ...state,
        sohCSVList: action.payload,
      }
    }
    case 'TOGGLE_3PL_STOCK_ON_HAND_SEARCH_FILTERS': {
      return {
        ...state,
        searchFilters: {
          ...searchFilters,
          statuses: action.payload,
        },
      }
    }
    case 'TOGGLE_3PL_SEARCH_STATUS_FILTERS': {
      return {
        ...state,
        statuses: action.payload,
      }
    }
    case 'TOGGLE_3PL_SET_LOCATION_SEARCH_FILTER_VALUES': {
      return {
        ...state,
        locations: action.payload,
      }
    }
    case 'TOGGLE_3PL_SET_STATUS_SEARCH_FILTER_VALUES': {
      return {
        ...state,
        statuses: action.payload,
      }
    }
    default: {
      return state
    }
  }
}

export default ThreePlStockOnHandReducer
